var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 
  	'text-white p-3 font-semibold focus:outline-none mr-2' : true,
  	'rounded' : _vm.isRounded,
  	'w-full' : _vm.isFullWidth,
  	'w-48' : !_vm.isFullWidth,
  	'bg-blue-500 hover:bg-blue-600' : _vm.color == 'blue', 
  	'bg-red-500 hover:bg-red-600' : _vm.color == 'red',
  	'bg-green-500 hover:bg-green-600' : _vm.color == 'green',
  	'bg-gray-500 hover:bg-gray-600' : _vm.color == 'gray'
  },on:{"click":_vm.onClickLocal}},[(_vm.loading || _vm.localLoading )?[_c('img',{staticClass:"inline",attrs:{"src":"/static/img/ajax-loader.gif"}})]:[_vm._v(_vm._s(_vm.label))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }